import { Button, styled } from '@mui/material';
import { useState } from 'react';
import { WidgetModal } from './WidgetModal/WidgetModal';
import { useAtom } from 'jotai';
import { aggregatedReportState } from '../../../../../../state/UIState';
import { generateId } from '../../../../../../utils/generateId';
import { QuestionOption, TWidgetDataType, WIDGET_TYPE } from '../../../../../../types';

const Wrapper = styled('div')``;

export const AddWidget = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [aggregatedReport, setAggregatedReport] = useAtom(aggregatedReportState);

  const handleSubmit = ({
    questionId,
    widgetType,
    questionAnswer,
    widgetDataType,
    startYear,
    endYear,
  }: {
    questionId: string;
    widgetType: WIDGET_TYPE;
    questionAnswer?: QuestionOption;
    widgetDataType: TWidgetDataType;
    startYear?: number;
    endYear?: number;
  }) => {
    if (!aggregatedReport) return;

    const widget = {
      id: generateId(),
      questionId,
      widgetType,
      questionAnswer,
      widgetDataType,
      startYear,
      endYear,
    };

    setAggregatedReport({
      ...aggregatedReport,
      widgets: [...(aggregatedReport?.widgets || []), widget],
    });

    setIsModalOpen(false);
  };

  return (
    <Wrapper>
      <Button
        style={{ display: 'flex', width: '100%' }}
        variant='outlined'
        onClick={() => setIsModalOpen(true)}
        disabled={!aggregatedReport?.selectedColumns?.length}
      >
        + Add Widget
      </Button>
      <WidgetModal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        title='Add Widget'
        confirmBtnText='Add Widget'
        handleSubmit={handleSubmit}
      />
    </Wrapper>
  );
};
